import { useRef, useState, useEffect, forwardRef } from "react";
import { Swiper } from "swiper/react";
// import ChevronRightRounded from "../icons/chevron-right-rounded";
// import ChevronLeftRounded from "../icons/chevron-left-rounded";
import { m } from "framer-motion";
import {
  Navigation,
  Pagination,
  Autoplay,
  EffectFade,
  Mousewheel,
} from "swiper/modules";

import cn from "classnames";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";

const Carousel = ({
  children,
  className = "",
  total = 0,
  loop = true,
  slidesPerView,
  navigation = true,
  pagination = false,
  autoplay = false,
  activeIndex = 0,
  breakpoints,
  showNavAbove = true,
  customPagination = false,
  setCurrentSlide,
  title = "Read More Like this",
  initialSlide = 0,
  centeredSlides = false,
  description,
  ...props
}) => {
  const [swiper, setSwiper] = useState();
  const [index, setIndex] = useState(initialSlide);
  const prevRef = useRef();
  const nextRef = useRef();

  useEffect(() => {
    if (swiper && swiper.navigation) {
      swiper.params.navigation.prevEl = prevRef.current;
      swiper.params.navigation.nextEl = nextRef.current;
      swiper.navigation.init();
      swiper.navigation.update();
      swiper.on("slideChange", function () {
        if (typeof setCurrentSlide === "function") {
          setIndex(swiper.realIndex);

          setCurrentSlide(swiper.realIndex);
        } else {
        }
      });
    }
  }, [swiper]);
  swiper?.on("slideChange", function (e) {
    setIndex(swiper.realIndex);
  });
  return (
    <div className={`carouselWrapper relative flex flex-col w-full`}>
      <Swiper
        modules={[Navigation, Autoplay, Pagination, EffectFade, Mousewheel]}
        loop={loop}
        slidesPerView={slidesPerView}
        autoplay={autoplay}
        breakpoints={breakpoints}
        pagination={pagination}
        className="w-full"
        initialSlide={initialSlide}
        onSwiper={setSwiper}
        centeredSlides={centeredSlides}
        // navigation={{
        //   prevEl: prevRef.current ? prevRef.current : undefined, // Assert non-null
        //   nextEl: nextRef.current ? nextRef.current : undefined, // Assert non-null
        // }}
        {...props}
      >
        {children}
      </Swiper>
    </div>
  );
};
// const NextButton = forwardRef(({ scrolling, variant, className }, ref) => {
//   return (
//     <button
//       ref={ref}
//       aria-label="next-button"
//       className={cn(
//         `transition duration-300 ease-in-out ${scrolling ? "opacity-70" : ""}`,
//         className,
//         {
//           "fixed top-1/2 md:right-8 right-2 -translate-y-1/2 transform z-[100] text-white":
//             variant === "side",
//           "relative text-darkGrey": variant === "top",
//         }
//       )}
//     >
//       <m.div
//         // initial={{ opacity: 0, y: 100 }}
//         // whileInView={{ opacity: 100, y: 0 }}
//         // transition={{ duration: 1, delay: 0.5 }}
//         // viewport={{ once: true }}
//         className="md:w-8 md:h-8 w-6 h-6"
//       >
//         <ChevronRightRounded />
//       </m.div>
//     </button>
//   );
// });
// NextButton.displayName = "NextButton"; // Add displayName

// const PrevButton = forwardRef(({ scrolling, variant, className }, ref) => {
//   return (
//     <button
//       ref={ref}
//       aria-label="prev-button"
//       className={cn(
//         `transition duration-300 ease-in-out ${scrolling ? "opacity-70" : ""}`,
//         className,
//         {
//           "fixed top-1/2 md:left-8 left-2 -translate-y-1/2 transform text-white z-10":
//             variant === "side",
//           "relative text-darkGrey": variant === "top",
//         }
//       )}
//     >
//       <m.div
//         className="md:w-8 md:h-8 w-6 h-6"
//         // initial={{ opacity: 0, y: 100 }}
//         // whileInView={{ opacity: 100, y: 0 }}
//         // transition={{ duration: 1, delay: 0.5 }}
//         // viewport={{ once: true }}
//       >
//         <ChevronLeftRounded />
//       </m.div>
//     </button>
//   );
// });
// PrevButton.displayName = "PrevButton"; // Add displayName
export default Carousel;
